// Mirror of the mobile app's presence staleness rule (src/utils/presence.ts).
// Presence has no server-side onDisconnect, so users/{uid}.online can be left
// stuck `true` by a force-kill. The app heartbeats lastSeen roughly every 60s
// while foregrounded, so a user whose lastSeen hasn't advanced within
// PRESENCE_STALE_MS is treated offline regardless of the online flag.
export const PRESENCE_STALE_MS = 150000; // 2.5× the 60s heartbeat

// `lastSeen` is a Firestore Timestamp (has .toDate()), a JS Date, or null.
export function isPresenceOnline(online, lastSeen) {
  if (!online) return false;
  const date = lastSeen && typeof lastSeen.toDate === "function" ? lastSeen.toDate() : lastSeen;
  if (!date) return true; // online with no timestamp — trust the flag
  return Date.now() - date.getTime() < PRESENCE_STALE_MS;
}
